export default __webpack_public_path__ + "static/media/ChevyFavicon.445e4033.ico";